import React from 'react';
import { IconProps } from '.';

const SvgBoxUnload = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m22.516 7.726-2.396 4.148a6 6 0 1 1-7.57 9.15L1.924 14.891a2.25 2.25 0 1 1 2.25-3.897l.65.375 6-10.392 11.692 6.75ZM11.19 18.508a6.01 6.01 0 0 1-.182-1.837l-7.585-4.379a.75.75 0 0 0-.75 1.299l8.517 4.917Zm.113-3.399-5.18-2.991 5.25-9.093 3.03 1.75-2.5 4.33 3.031 1.75 2.5-4.33 3.032 1.75-1.723 2.982a6.003 6.003 0 0 0-7.44 3.851Zm4.832-9.334-.433-.25-1.75 3.03.433.25 1.75-3.03ZM21.5 17a4.5 4.5 0 1 1-5.25-4.438v5.127l-1.72-1.72-1.06 1.061L17 20.56l3.53-3.53-1.06-1.06-1.72 1.72v-5.128A4.501 4.501 0 0 1 21.5 17Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBoxUnload;
